module.exports = __webpack_public_path__ + "static/feature-macbook-d524ef217c9d05e388444fb8b1084b37.png";